import React from 'react';
import {
  Container,
  VStack,
  Heading,
  Text,
  Box,
  useColorModeValue,
  Divider,
} from '@chakra-ui/react';

const TermsOfService: React.FC = () => {
  const bg = useColorModeValue('white', 'gray.800');
  const textColor = useColorModeValue('gray.900', 'white');
  const secondaryColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Container maxW="4xl" py={8}>
        <VStack spacing={6} align="stretch" bg={bg} p={8} borderRadius="lg">
          <Heading size="xl" color={textColor}>
            Terms of Service
          </Heading>
          <Text color={secondaryColor} fontSize="sm">
            Last updated: {new Date().toLocaleDateString()}
          </Text>

          <Divider />

          <VStack spacing={6} align="stretch">
            <Box>
              <Heading size="md" mb={3} color={textColor}>
                1. Acceptance of Terms
              </Heading>
              <Text color={secondaryColor}>
                By accessing and using Vindie Stream, you accept and agree to be bound by
                the terms and provision of this agreement. If you do not agree to these
                terms, please do not use our service.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                2. User Accounts
              </Heading>
              <Text color={secondaryColor}>
                You are responsible for maintaining the confidentiality of your account
                credentials and for all activities that occur under your account. You agree
                to notify us immediately of any unauthorized use of your account.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                3. Content Ownership and Licensing
              </Heading>
              <Text color={secondaryColor} mb={2}>
                Creators retain ownership of their content but grant Vindie Stream:
              </Text>
              <Box as="ul" mt={2} pl={6} color={secondaryColor}>
                <li>A worldwide, non-exclusive license to host, display, and distribute your content</li>
                <li>The right to promote your content on our platform</li>
                <li>The right to use your content for platform promotion and marketing</li>
              </Box>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                4. Prohibited Content
              </Heading>
              <Text color={secondaryColor} mb={2}>
                You agree not to upload, post, or transmit any content that:
              </Text>
              <Box as="ul" mt={2} pl={6} color={secondaryColor}>
                <li>Violates any laws or regulations</li>
                <li>Infringes on intellectual property rights</li>
                <li>Contains hate speech, harassment, or discrimination</li>
                <li>Is fraudulent, misleading, or deceptive</li>
                <li>Contains explicit sexual content without proper age restrictions</li>
                <li>Promotes illegal activities</li>
              </Box>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                5. Content Moderation
              </Heading>
              <Text color={secondaryColor}>
                We reserve the right to review, moderate, and remove any content that
                violates these terms. Violations may result in warnings, suspensions, or
                permanent bans from the platform.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                6. Copyright and DMCA
              </Heading>
              <Text color={secondaryColor}>
                We respect intellectual property rights and comply with the Digital
                Millennium Copyright Act (DMCA). If you believe your copyright has been
                infringed, please submit a DMCA takedown request through our platform.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                7. Payments and Refunds
              </Heading>
              <Text color={secondaryColor}>
                All payments are processed securely through Stripe. Subscriptions are
                billed automatically according to your selected plan. Refunds are handled
                on a case-by-case basis. Donations are final unless proven fraudulent.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                8. Service Availability
              </Heading>
              <Text color={secondaryColor}>
                We strive to maintain service availability but do not guarantee uninterrupted
                access. We reserve the right to modify, suspend, or discontinue any part of
                the service at any time.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                9. Limitation of Liability
              </Heading>
              <Text color={secondaryColor}>
                To the maximum extent permitted by law, Vindie Stream shall not be liable
                for any indirect, incidental, special, consequential, or punitive damages
                resulting from your use of the service.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                10. Termination
              </Heading>
              <Text color={secondaryColor}>
                We may terminate or suspend your account immediately, without prior notice,
                for conduct that we believe violates these Terms of Service or is harmful
                to other users, us, or third parties.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                11. Changes to Terms
              </Heading>
              <Text color={secondaryColor}>
                We reserve the right to modify these terms at any time. We will notify
                users of significant changes. Continued use of the service after changes
                constitutes acceptance of the new terms.
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb={3} color={textColor}>
                12. Contact Information
              </Heading>
              <Text color={secondaryColor}>
                For questions about these Terms of Service, please contact us through
                the support channels available on our platform.
              </Text>
            </Box>
          </VStack>
        </VStack>
      </Container>
  );
};

export default TermsOfService;

